var map = {
	"./featured-item/coach.webp": 239,
	"./featured-item/coach@2x.webp": 167,
	"./featured-item/coach@3x.webp": 169,
	"./featured-item/cuff.webp": 241,
	"./featured-item/cuff@2x.webp": 171,
	"./featured-item/cuff@3x.webp": 173,
	"./featured-item/fastclix_lancets.webp": 243,
	"./featured-item/fastclix_lancets@2x.webp": 175,
	"./featured-item/fastclix_lancets@3x.webp": 177,
	"./featured-item/fastclix_lancing_kit.webp": 245,
	"./featured-item/fastclix_lancing_kit@2x.webp": 179,
	"./featured-item/fastclix_lancing_kit@3x.webp": 181,
	"./featured-item/guide.webp": 247,
	"./featured-item/guide@2x.webp": 183,
	"./featured-item/guide@3x.webp": 185,
	"./featured-item/guide_me.webp": 249,
	"./featured-item/guide_me@2x.webp": 187,
	"./featured-item/guide_me@3x.webp": 189,
	"./featured-item/mysugr_coach_voucher_based_1.webp": 251,
	"./featured-item/mysugr_coach_voucher_based_1@2x.webp": 191,
	"./featured-item/mysugr_coach_voucher_based_1@3x.webp": 193,
	"./featured-item/pro.webp": 253,
	"./featured-item/pro@2x.webp": 195,
	"./featured-item/pro@3x.webp": 197,
	"./featured-item/scale.webp": 255,
	"./featured-item/scale@2x.webp": 199,
	"./featured-item/scale@3x.webp": 201,
	"./featured-item/softclix_lancets.webp": 257,
	"./featured-item/softclix_lancets@2x.webp": 203,
	"./featured-item/softclix_lancets@3x.webp": 205,
	"./featured-item/softclix_lancing_kit.webp": 259,
	"./featured-item/softclix_lancing_kit@2x.webp": 207,
	"./featured-item/softclix_lancing_kit@3x.webp": 209,
	"./featured-item/strips_subscription_guide.webp": 261,
	"./featured-item/strips_subscription_guide@2x.webp": 211,
	"./featured-item/strips_subscription_guide@3x.webp": 213,
	"./item/coach.webp": 672,
	"./item/coach@2x.webp": 294,
	"./item/coach@3x.webp": 295,
	"./item/cuff.webp": 673,
	"./item/cuff@2x.webp": 296,
	"./item/cuff@3x.webp": 297,
	"./item/fastclix_lancets.webp": 674,
	"./item/fastclix_lancets@2x.webp": 298,
	"./item/fastclix_lancets@3x.webp": 299,
	"./item/fastclix_lancing_kit.webp": 675,
	"./item/fastclix_lancing_kit@2x.webp": 300,
	"./item/fastclix_lancing_kit@3x.webp": 301,
	"./item/guide.webp": 676,
	"./item/guide@2x.webp": 302,
	"./item/guide@3x.webp": 303,
	"./item/guide_me.webp": 677,
	"./item/guide_me@2x.webp": 304,
	"./item/guide_me@3x.webp": 305,
	"./item/guide_strips.webp": 678,
	"./item/guide_strips@2x.webp": 306,
	"./item/guide_strips@3x.webp": 307,
	"./item/mysugr_coach_voucher_based_1.webp": 679,
	"./item/mysugr_coach_voucher_based_1@2x.webp": 308,
	"./item/mysugr_coach_voucher_based_1@3x.webp": 309,
	"./item/pro.webp": 680,
	"./item/pro@2x.webp": 310,
	"./item/pro@3x.webp": 311,
	"./item/scale.webp": 681,
	"./item/scale@2x.webp": 312,
	"./item/scale@3x.webp": 313,
	"./item/softclix_lancets.webp": 682,
	"./item/softclix_lancets@2x.webp": 314,
	"./item/softclix_lancets@3x.webp": 315,
	"./item/softclix_lancing_kit.webp": 683,
	"./item/softclix_lancing_kit@2x.webp": 316,
	"./item/softclix_lancing_kit@3x.webp": 317,
	"./item/strips_subscription_guide.webp": 684,
	"./item/strips_subscription_guide@2x.webp": 318,
	"./item/strips_subscription_guide@3x.webp": 319
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 293;